import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    root: {
      color: 'rgb(102, 102, 102)',
      padding: '0 10px',
      textTransform: 'uppercase',
    },
  });

export type Styles = WithStyles<typeof styles>;
